<script setup lang="ts">
import { WysiwygEditorAsync as WysiwygEditor } from "@/canvasses/WysiwygEditorAsync";
import MapPositionPicker from "@/components/map/MapPositionPicker.vue";
import type { Settings } from "./types";

const settings = defineModel<Settings>({ required: true });
</script>

<template>
  <div class="multi-columns">
    <div class="column">
      <div>
        <label for="name"> Impressum URL</label>
        <input
          id="name"
          v-model="settings.impressUrl"
          type="url"
          name="name"
          required
        />
      </div>
      <div>
        <label for="name"> Datenschutz URL</label>
        <input
          id="name"
          v-model="settings.privacyPolicyUrl"
          type="url"
          name="name"
          required
        />
      </div>

      <div>
        <label for="name"> Consent Text für Kontakte</label>
        <WysiwygEditor v-model="settings.contactConsentText" />
      </div>
      <div>
        <label for="name"> Consent Text für Nutzer:innen</label>
        <WysiwygEditor v-model="settings.userConsentText" />
      </div>
      <div>
        <label>Standard-Kartenposition für neue Gebiete</label>
        <p class="info-text">
          Karte so verschieben und zoomen, wie neue Gebiete starten sollen. Der
          aktuelle Ausschnitt wird beim Speichern übernommen.
        </p>
        <MapPositionPicker v-model="settings.defaultMapPosition" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.info-text {
  color: var(--text-color-muted);
}
</style>
